export function createRegexFromArray(
  terms: string[],
  exactStrings: string[] = []
): string {
  let regexPattern = "";

  if (terms.length > 0) {
    const escapedTerms = terms.map((term) =>
      term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    );
    regexPattern = `(?:${escapedTerms.join("|")})`;
  }

  if (exactStrings.length > 0) {
    const exactStringsPattern = exactStrings
      .map((str) => `\\b${str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`)
      .join("|");
    regexPattern += (regexPattern ? "|" : "") + exactStringsPattern;
  }
  return regexPattern;
}
